<template lang="pug">
    v-card(
        elevation="4"
        shaped
    )
        v-toolbar(dense)
            v-icon.mr-2 mdi-phone
            v-toolbar-title Organizations
            
        v-card-text
            TableFixedHeader(
                v-if="validDashboardSummaryOrganizations"
                dark
                :items="dashboardSummaryOrganizations"
                :num-of-sticky-columns="1"
                :height="500"
            )

                template(v-slot:column-header-first-title)
                    | Organization

                template(v-slot:th-default)
                    th.text-center.no-wrap.white--text IB Calls
                    th.text-center.no-wrap.white--text Drop %
                    th.text-center.no-wrap.white--text OB Calls
                    th.text-center.no-wrap.white--text Contact %
                    th.text-center.no-wrap.white--text New Appts

                template(v-slot:column-header-first-content-value="slotProps") 
                    | {{ slotProps.item.organization_name }}

                template(v-slot:tr-default="slotProps")
                    td.text-center.no-wrap {{ slotProps.item.phone_inbound_call_count | number }}
                    td.text-center.no-wrap {{ (calculateDropPercentage(slotProps.idx) || 0).toFixed(2) | number }}%
                    td.text-center.no-wrap {{ slotProps.item.phone_outbound_call_count | number }}
                    td.text-center.no-wrap {{ calculateContactPercentage(slotProps.idx) | number }}%
                    td.text-center.no-wrap {{ slotProps.item.appointment_new_count | number }}

            v-alert(type="error" v-else dense)
                | No organizations found
</template>

<script lang="ts">
    import Vue from 'vue';
    import VolieState  from "@/store";

    // Components
    import TableFixedHeader from '@/components/shared/table_fixed_header.vue';

    // Data
    import { GetOrganizationUsers } from "@/data";

    // Helpers
    import { agentDropRate } from '@/helpers/dashboard_summary';

    export default Vue.extend({
        data() {
            return {
                dashboardSummaryOrganizations: [],
                organizationUsers: [],
            }
        },
        methods: { 
            buildRenderOrganizations() {
                
                // reset
                this.dashboardSummaryOrganizations = [];
                if (!this.validBaseDashboardSummaries) {
                    return;
                }

                // Loop over base dashboard summaries
                for (let i = 0; i < this.baseDashboardSummaries.length; i++) {

                    // Init
                    const baseDashboardSummary = this.baseDashboardSummaries[i];
                    if (!baseDashboardSummary || !(baseDashboardSummary?.base_dashboard_summary?.id > 0) || baseDashboardSummary?.base_dashboard_summary?.owner_type !== "organization") {
                        continue;
                    }

                    // only show organizations, not team organizations
                    if (baseDashboardSummary?.base_dashboard_summary?.team_id > 0) {
                        continue;
                    }

                    // find data's day period
                    const sourceDayPeriod = baseDashboardSummary?.data?.dashboard_summary_periods?.find(i => i.period_type === "day");
                    if (!sourceDayPeriod || !(sourceDayPeriod.id > 0)) {
                        continue;
                    }

                    // create a new in-memory instance (shallow copy)
                    const dayPeriod = { ...sourceDayPeriod };

                    // find organization user
                    const organizationUser = this.organizationUsers.find(i => i.organization_id === baseDashboardSummary?.base_dashboard_summary?.owner_id);
                    if (!organizationUser) {
                        continue;
                    }

                    // add organization name
                    dayPeriod.organization_name = organizationUser.organization_name;

                    // add to organizations
                    this.dashboardSummaryOrganizations.push(dayPeriod);
                }

                // sort by organization name
                this.dashboardSummaryOrganizations.sort((a, b) => a.organization_name.localeCompare(b.organization_name));
            },
            calculatePercentage(x, y) {
                if (!x || !y) {
                    return 0;
                }

                return Math.round((x / y) * 100.0);
            },
            calculateContactPercentage(idx) {
                const summary = this.dashboardSummaryOrganizations[idx];
                return this.calculatePercentage(summary.phone_outbound_contact_count, summary.phone_outbound_call_count);
            },
            calculateDropPercentage(idx) {
                return agentDropRate(this.dashboardSummaryOrganizations[idx]);
            },
            getOrganizationUsers() {
                GetOrganizationUsers().then((response) => {
                    if (!!response.Data && !!response.Data.organization_users && response.Data.organization_users.length > 0) {
                        this.organizationUsers = response.Data.organization_users;
                    }
                });
            },
        },
        computed: {
            baseDashboardSummaries() {
                return VolieState.baseDashboardSummaries();
            },
            validBaseDashboardSummaries() {
                return this.baseDashboardSummaries?.length > 0;
            },
            validDashboardSummaryOrganizations() {
                return this.dashboardSummaryOrganizations?.length > 0;
            }
        },
        components: {
            TableFixedHeader
        },
        props: {
            forceOrganizationUsers: Array,
        },
        watch: {
            baseDashboardSummaries: {
                deep: true,
                handler() {
                    this.buildRenderOrganizations();
                }
            }
        },
        created() {
            this.organizationUsers = this.forceOrganizationUsers || [];
            if (this.organizationUsers.length === 0) {
                this.getOrganizationUsers();
            }
        },
    });
</script>

<style lang="scss" scoped>
</style>